import { computed } from "@vue/composition-api";
import { NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import config from "@/config";

export const notificationsTypes = computed(() => {
  return {
    all: undefined,
    subscriptions: [NotificationType.SUBSCRIPTION_PURCHASE_PROVIDER],
    purchases: [NotificationType.CONTENT_PURCHASE],
    ...(config.featureFundraisingGoals
      ? {
          goals: [
            NotificationType.FUNDRAISING_GOAL_FINISHED,
            NotificationType.FUNDRAISING_GOAL_STARTED,
            NotificationType.FUNDRAISING_GOAL_DONATION_CREATED,
            NotificationType.FUNDRAISING_GOAL_REWARD_PURCHASED,
          ],
        }
      : {}),
    followers: [NotificationType.PROFILE_FOLLOWING],
    likes: [NotificationType.LIKE],
    comments: [NotificationType.POST_REVIEW_CREATED, NotificationType.POST_REVIEW_MENTIONED],
    ...(config.featureAppointments
      ? {
          appointments: [
            NotificationType.APPOINTMENT_REQUESTED,
            NotificationType.APPOINTMENT_CANCELLED_PROVIDER,
            NotificationType.APPOINTMENT_REMINDER_PROVIDER,
          ],
        }
      : {}),
    participationConsent: [
      NotificationType.PARTICIPANT_CREATED,
      NotificationType.PARTICIPANT_APPROVED,
      NotificationType.PARTICIPANT_REJECTED,
    ],
    other: [
      NotificationType.FULL_CREATOR_APPLICATION_APPROVED,
      NotificationType.FULL_CREATOR_APPLICATION_DECLINED,
      NotificationType.LIMITED_CREATOR_APPLICATION_APPROVED,
      NotificationType.LIMITED_CREATOR_APPLICATION_DECLINED,
    ],
  };
});

export type NotificationsKey = keyof typeof notificationsTypes.value;
